import React from "react";
import { Link } from "react-router-dom";
import { colors, typography, surfaces, utils } from "../styles/index";

// The card the login, sign-up, invitation and demo pages sit in (logistics-workflow's login layout).
export default function AuthCard({ subtitle, children, wide }) {
  return (
    <div style={{ minHeight: "100vh", background: colors.bgSoft, padding: 24, ...utils.centerFlex }}>
      <div style={{ ...surfaces.card, padding: 40, width: "100%", maxWidth: wide ? 600 : 420 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Link to="/" style={{ textDecoration: "none", color: colors.textDark }}>
            <img src="/logo.svg" alt="" style={{ height: 48 }} />
            <div style={{ fontWeight: 700, fontSize: "1.25rem", marginTop: 4 }}>SimulateJob</div>
          </Link>
          {subtitle && <div style={{ ...typography.small, color: colors.textMuted, marginTop: 4 }}>{subtitle}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}
